import { sidebarStore } from "@/store/sidebar"

import { SidebarStoreState } from "../types"

export function setOpen(isOpen: boolean): void {
  sidebarStore.setState({ isOpen })
}

export function toggle(): void {
  sidebarStore.setState((state: SidebarStoreState) => ({
    isOpen: !state.isOpen,
  }))
}
